import { RecentlyViewed16 } from '@carbon/icons-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
// import { CustomerPortalButtonType } from 'api/customer-portal/theme-api';
import { ReactComponent as Folder16 } from 'assets/svgs/folder-filled.svg';
import { SpotlightMessage20 } from 'components/atoms/icons/spotlight-message';
import { ALL_COLORS_WITHOUT_GRAY } from 'components/colors';
import { useIsTablet } from 'hooks/use-media-query';
import { getRandomColor } from 'utils/get-random-color';
// import { CpButton } from '../../components/cp-button';
import {
  SideBarItem,
  SideBarItemIcon,
  SideBarItemName,
  SideBarSection,
  SideBarSectionTitle,
  Sidebar,
} from '../common/side-bar';
import { CpSpaceProps, RECENTS_FOLDER_ID, SPOTLIGHT_FOLDER_ID } from './types';

export const CpSpacesSidePane: React.FC<
  Pick<CpSpaceProps, 'search' | 'currentSpace' | 'onSpaceClick' | 'data'>
> = ({ search, currentSpace, onSpaceClick, data }) => {
  const isResponsive = useIsTablet();

  const content = (
    <Sidebar>
      {/* <AddButtonWrapper>
        <AddButton
          cpType={CustomerPortalButtonType.Primary}
          icon={<Add16 />}
          data-cy="cp.spaces.add-space"
        >
          <FormattedMessage id="new" />
        </AddButton>
      </AddButtonWrapper> */}
      <SideBarSection>
        <SideBarItem
          data-cy="cp.spaces.spotlighted_folder"
          active={currentSpace?.spaceId === SPOTLIGHT_FOLDER_ID}
          onClick={() => onSpaceClick('spotlight')}
        >
          <SideBarItemIcon>
            <SpotlightMessage20 />
          </SideBarItemIcon>
          <SideBarItemName>
            <FormattedMessage id="spotlight" />
          </SideBarItemName>
        </SideBarItem>
        <SideBarItem
          active={currentSpace?.spaceId === RECENTS_FOLDER_ID}
          onClick={() => onSpaceClick('recents')}
          data-cy="cp.spaces.recent_folder"
        >
          <SideBarItemIcon>
            <RecentlyViewed16 />
          </SideBarItemIcon>
          <SideBarItemName>
            <FormattedMessage id="recents" />
          </SideBarItemName>
        </SideBarItem>
      </SideBarSection>

      <SideBarSection>
        <SideBarSectionTitle>
          <FormattedMessage id="projects.tabs.spaces" />
        </SideBarSectionTitle>

        {data?.spaces?.map((sp) => {
          if (
            isResponsive &&
            !!search?.trim() &&
            !sp.spaceName.toLowerCase().includes(search.toLowerCase())
          ) {
            return <></>;
          }

          return (
            <SideBarItem
              active={currentSpace?.spaceId === sp.spaceId}
              key={sp.spaceId}
              onClick={() => onSpaceClick(sp.spaceId)}
              data-cy={`cp.spaces.space.${sp.spaceName}`}
            >
              <SideBarItemIcon
                color={getRandomColor(sp?.spaceName, ALL_COLORS_WITHOUT_GRAY)}
              >
                <Folder16 />
              </SideBarItemIcon>
              <SideBarItemName data-cy={`cp.spaces.space.${sp.spaceName}.name`}>
                {sp.spaceName}
              </SideBarItemName>
            </SideBarItem>
          );
        })}
      </SideBarSection>
    </Sidebar>
  );

  if (isResponsive) {
    return content;
  }

  return <>{!search?.trim() ? content : <></>}</>;
};
